import React, { useState } from "react";
import CommonHeadingNBtns from "../common-components/CommonHeadingNBtns";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import SelectDropdownLabel from "../components-react/SelectDropdownLabel";
import useGymsData from "../../hooks/useGymsData";
import { NOTIFICATION_ACCOUNT_TYPE_OPTIONS } from "../../data/Constants";
import {
  notifcationImmediateSchema,
  NotificationSheduleSchema,
} from "../../schema/schema";
import {
  add_immediate_notification,
  add_schedule_notification,
  update_notification,
  upload_file,
} from "../../data/ApiEndpoints";
import {
  commonPostPutApi,
  commonPostPutFormData,
} from "../../redux/reducers/commonApiSlice";
import { toast } from "react-toastify";
import moment from "moment";
import { subscriptionTypes } from "../common-data/DropdowData";
import Loader from "../ui/Loader";

const AddNotification = ({
  getNoticationList,
  closeModal,
  token,
  notificationType,
  isEdit,
  initialValue,
}) => {
  const dispatch = useDispatch();
  const { data: gymsData } = useGymsData();

  const initialData = {
    id: 1,
    notifications: [
      {
        id: 1,
      },
    ],
  };

  console.log("initialValue===>", initialValue);
  const [dates, setDates] = useState([initialData]);

  const [imageLoader, setImageLoader] = useState(false);

  // Add To Cloudfront
  const addToCloudfront = (url) => {
    setImageLoader(true);
    const formData = new FormData();
    formData.append("media", url);
    const result = dispatch(
      commonPostPutFormData({
        method: "POST",
        endpoint: upload_file,
        token,
        requestBody: formData,
      })
    );
    setImageLoader(false);
    return result;
  };

  const formik = useFormik({
    initialValues:
      notificationType === "push"
        ? initialValue && isEdit
          ? {
              ...initialValue,
              gym_id: initialValue?.gym_uid,
              media: initialValue?.image,
            }
          : {
              gym_id: "",
              date: Date.now(),
              name: "",
              title: "",
              message: "",
              media: "",
              dynamic_link: "",
              account_type: "",
              subscription_type: "",
              type: notificationType,
              status: "pending",
              time: "",
            }
        : {
            gym_id: "",
            account_type: "",
            name: "",
            subscription_type: "",
            type: notificationType,
            data: [
              {
                date: "",
                times: [
                  {
                    time: "",
                    title: "",
                    message: "",
                    image: "",
                    dynamic_link: "",
                  },
                ],
              },
            ],
          },
    validationSchema:
      notificationType === "push"
        ? notifcationImmediateSchema
        : NotificationSheduleSchema,
    onSubmit: async (values) => {
      const method = isEdit ? "PUT" : "POST";
      const endpoint = isEdit
        ? update_notification
        : notificationType === "push"
        ? add_immediate_notification
        : add_schedule_notification;

      let requestConfig = { method, endpoint, token };

      if (isEdit) {
        const { media, ...restValues } = values;
        const editPayload = {
          ...restValues,
          image: media,
        };
        requestConfig.payload = editPayload;
      } else if (notificationType === "push") {
        const formData = new FormData();
        Object.keys(values).forEach((key) => {
          if (values[key] !== undefined && values[key] !== null) {
            formData.append(key, values[key]);
          }
        });
        requestConfig.requestBody = formData;
      } else {
        requestConfig.payload = values;
      }

      const apiFunction = isEdit
        ? commonPostPutApi
        : notificationType === "push"
        ? commonPostPutFormData
        : commonPostPutApi;

      const result = await dispatch(apiFunction(requestConfig));

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");
        closeModal();
        getNoticationList();
      } else {
        const errorMessage = result?.error?.message || result?.payload?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    },
  });

  const addDate = () => {
    setDates((prevDates) => {
      return [
        ...prevDates,
        {
          id: prevDates.length + 1,
          notifications: [
            {
              id: 1,
            },
          ],
        },
      ];
    });

    formik.setFieldValue("data", [
      ...formik.values.data,
      {
        date: "",
        times: [
          { time: "", title: "", message: "", image: "", dynamic_link: "" },
        ],
      },
    ]);
  };

  const addNotification = (dateIndex) => {
    setDates((prevDates) =>
      prevDates.map((date, idx) =>
        idx === dateIndex
          ? {
              ...date,
              notifications: [
                ...date.notifications,
                { id: date.notifications.length + 1 },
              ],
            }
          : date
      )
    );
    formik.setFieldValue(`data[${dateIndex}].times`, [
      ...formik.values.data[dateIndex].times,
      { time: "", title: "", message: "", image: "", dynamic_link: "" },
    ]);
  };

  const handleChangeImage = async (event) => {
    if (isEdit) {
      setImageLoader(true);
      const res = await addToCloudfront(event.currentTarget.files[0]);
      if (res?.payload?.status === true) {
        formik.setFieldValue("media", res?.payload?.img_url || "");
      }
      setImageLoader(false);
    } else {
      formik.setFieldValue("media", event.currentTarget.files[0]);
    }
  };

  console.log("formik--->", formik);

  const handleRemoveImage = (removeType) => {
    formik.setFieldValue(removeType, "");
  };

  return (
    <div className="createNewCTOModalContainer mod-width-100p">
      <CommonHeadingNBtns
        title={
          isEdit
            ? `Edit Notification`
            : `Add ${
                notificationType === "push" ? "Immediate" : "Schedule"
              } Notification`
        }
        onClick={formik.handleSubmit}
        isLoading={formik.isSubmitting}
        btnTxt="Save"
        onClose={closeModal}
      />

      <form className="formContainer " onSubmit={formik.handleSubmit}>
        <div className="formInputsGrid threeGridSystem">
          <div className="formInputBox">
            <label>
              Select Gym
              <span className="text-danger">*</span>
            </label>
            <div
              className={`commonWrapper dropdownCommonWrapper ${
                formik.errors.gym_id && formik.touched.gym_id ? "formError" : ""
              }`}
            >
              <SelectDropdownLabel
                name="Select Gym"
                options={gymsData || []}
                value={gymsData.find(
                  (option) => option.value === formik.values.gym_id
                )}
                setSelectedOption={(selectedOption) => {
                  formik.setFieldValue("gym_id", selectedOption?.value);
                }}
              />
            </div>

            {formik.touched.gym_id && formik.errors.gym_id ? (
              <div className="error-message">{formik.errors.gym_id}</div>
            ) : null}
          </div>
          <div className="formInputBox">
            <label>
              Account Type
              <span className="text-danger">*</span>
            </label>
            <div
              className={`commonWrapper dropdownCommonWrapper ${
                formik.errors.account_type && formik.touched.account_type
                  ? "formError"
                  : ""
              }`}
            >
              <SelectDropdownLabel
                name="Select Account Type"
                options={NOTIFICATION_ACCOUNT_TYPE_OPTIONS || []}
                value={NOTIFICATION_ACCOUNT_TYPE_OPTIONS.find(
                  (option) => option.value === formik.values.account_type
                )}
                setSelectedOption={(selectedOption) => {
                  formik.setFieldValue("account_type", selectedOption?.value);
                }}
              />
            </div>

            {formik.touched.account_type && formik.errors.account_type ? (
              <div className="error-message">{formik.errors.account_type}</div>
            ) : null}
          </div>

          <div className="formInputBox">
            <label>
              Name
              <span className="text-danger">*</span>
            </label>
            <div className="formWapper">
              <input
                type="text"
                name="name"
                placeholder="Name"
                value={formik.values.name}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className={`inputClass ${
                  formik.errors.name && formik.touched.name ? "formError" : ""
                }`}
              />
            </div>
            {formik.touched.name && formik.errors.name ? (
              <div className="error-message">{formik.errors.name}</div>
            ) : null}
          </div>
        </div>

        {notificationType === "push" ? (
          <div className="formInputsGrid threeGridSystem">
            <div className="formInputBox">
              <label>Dynamic URL</label>
              <div className="formWapper">
                <input
                  type="text"
                  name="dynamic_link"
                  placeholder="Dynamic URL"
                  value={formik.values.dynamic_link || ""}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  className={`inputClass ${
                    formik.errors.dynamic_link && formik.touched.dynamic_link
                      ? "formError"
                      : ""
                  }`}
                />
              </div>
              {formik.touched.dynamic_link && formik.errors.dynamic_link ? (
                <div className="error-message">
                  {formik.errors.dynamic_link}
                </div>
              ) : null}
            </div>

            <div className="formInputBox">
              <label>
                Title
                <span className="text-danger">*</span>
              </label>
              <div className="formWapper">
                <input
                  type="text"
                  name="title"
                  placeholder="title"
                  value={formik.values.title || ""}
                  className={`inputClass ${
                    formik.errors.title && formik.touched.title
                      ? "formError"
                      : ""
                  }`}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </div>
              {formik.errors?.title && formik.touched?.title && (
                <div className="error-message">{formik.errors?.title}</div>
              )}
            </div>

            <div className="formInputBox">
              <label>
                Start Time
                <span className="text-danger">*</span>
              </label>
              <div className="formWapper">
                <input
                  type="time"
                  name="time"
                  value={formik.values.time}
                  className={`inputClass ${
                    formik.errors.time && formik.touched.time ? "formError" : ""
                  }`}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </div>
              {formik.touched.time && formik.errors.time ? (
                <div className="error-message">{formik.errors.time}</div>
              ) : null}
            </div>

            <div className="formInputBox">
              <label>Subscription Type</label>
              <div className={`commonWrapper dropdownCommonWrapper`}>
                <SelectDropdownLabel
                  name="Select Subscription Type"
                  options={subscriptionTypes}
                  value={subscriptionTypes.find(
                    (option) => option.value === formik.values.subscription_type
                  )}
                  setSelectedOption={(selectedOption) => {
                    formik.setFieldValue(
                      "subscription_type",
                      selectedOption?.value
                    );
                  }}
                />
              </div>
            </div>

            <div
              style={{
                display: "flex",
                gap: "10px",
                alignItems: "end",
              }}
            >
              <div className="formInputBox">
                <label>Image</label>

                <div
                  className=""
                  style={{
                    width: "100%",
                    height: "100%",
                    backgroundColor: "#fff",
                    borderRadius: "10px",
                  }}
                >
                  {formik.values.media ? (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      {isEdit ? (
                        imageLoader ? (
                          <Loader />
                        ) : (
                          <ImagePreview
                            image={formik.values.media}
                            handelRemove={() => handleRemoveImage("media")}
                          />
                        )
                      ) : (
                        formik.values.media && (
                          <ImagePreview
                            image={formik.values.media}
                            handelRemove={() => handleRemoveImage("media")}
                          />
                        )
                      )}

                      <div
                        style={{
                          padding: "10px",
                        }}
                      >
                        <input
                          type="file"
                          name="media"
                          className={`formInput`}
                          id="profileInput"
                          style={{
                            display: "none",
                          }}
                          onChange={handleChangeImage}
                        />
                        <label
                          style={{
                            cursor: "pointer",
                            color: "blue",
                            textDecoration: "underline",
                            fontSize: "20px",
                          }}
                          htmlFor="profileInput"
                        >
                          Change
                        </label>
                      </div>
                    </div>
                  ) : (
                    <input
                      type="file"
                      name="media"
                      className={`formInput`}
                      id="profileInput"
                      onChange={handleChangeImage}
                    />
                  )}
                </div>
              </div>

              {formik.touched.media && formik.errors.media ? (
                <div className="error-message">{formik.errors.media}</div>
              ) : null}
            </div>

            <div
              className="formInputBox"
              style={{
                gridColumn: "span 3",
              }}
            >
              <label>
                Message
                <span className="text-danger">*</span>
              </label>

              <textarea
                type="text"
                name="message"
                className={`inputClass ${
                  formik.errors.message && formik.touched.message
                    ? "formError"
                    : ""
                }`}
                placeholder="Message"
                value={formik.values.message || ""}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                style={{ height: "100px", padding: "10px" }}
              />
              {formik.touched.message && formik.errors.message ? (
                <div className="error-message">{formik.errors.message}</div>
              ) : null}
            </div>
          </div>
        ) : (
          <>
            {dates.map((date, dateIndex) => (
              <div
                className=""
                key={date.id}
                style={{
                  width: "100%",
                  border: "0.5px solid rgba(128, 128, 128, 0.5)",
                  padding: "20px",
                  borderRadius: "10px",
                }}
              >
                <div>
                  <div>
                    <BoldLabel onClick={addDate}>
                      Schedule Date {dateIndex + 1} +
                    </BoldLabel>
                  </div>
                  <div className="formInputsGrid twoGridSystem">
                    <div className="formInputBox">
                      <label>
                        Date <span className="text-danger">*</span>
                      </label>
                      <div className="formWapper">
                        <input
                          type="date"
                          name={`data[${dateIndex}].date`}
                          className={`formInput ${
                            formik.errors.data?.[dateIndex]?.date &&
                            formik.touched.data?.[dateIndex]?.date
                              ? "formError"
                              : ""
                          } ${
                            formik.values.data?.[dateIndex]?.date
                              ? "date-has-value"
                              : ""
                          }`}
                          placeholder="Joining Date"
                          value={
                            formik.values.data?.[dateIndex]?.date
                              ? moment(
                                  formik.values.data[dateIndex].date
                                ).format("YYYY-MM-DD")
                              : ""
                          }
                          onChange={(e) => {
                            const formattedDate = moment(
                              e.target.value,
                              "YYYY-MM-DD"
                            ).format("DD-MM-YYYY");
                            formik.setFieldValue(
                              `data[${dateIndex}].date`,
                              formattedDate
                            );
                          }}
                          onBlur={formik.handleBlur}
                        />
                      </div>

                      {formik.touched.data?.[dateIndex]?.date &&
                      formik.errors.data?.[dateIndex]?.date ? (
                        <div className="error-message">
                          {formik.errors.data?.[dateIndex]?.date}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>

                {/* Notification */}
                {date.notifications.map((notification, notifIndex) => (
                  <div
                    key={notification?.id}
                    style={{
                      width: "100%",
                      padding: "20px",
                    }}
                  >
                    <div>
                      <BoldLabel onClick={() => addNotification(dateIndex)}>
                        Notification {notifIndex + 1} +
                      </BoldLabel>
                    </div>
                    <div className="formInputsGrid twoGridSystem">
                      <div className="formInputBox">
                        <label>
                          Title
                          <span className="text-danger">*</span>
                        </label>
                        <div className="formWapper">
                          <input
                            type="text"
                            name={`data[${dateIndex}].times[${notifIndex}].title`}
                            placeholder="title"
                            value={
                              formik.values.data?.[dateIndex]?.times?.[
                                notifIndex
                              ]?.title || ""
                            }
                            className={`inputClass ${
                              formik.errors.data?.[dateIndex]?.times?.[
                                notifIndex
                              ]?.title &&
                              formik.touched.data?.[dateIndex]?.times?.[
                                notifIndex
                              ]?.title
                                ? "formError"
                                : ""
                            }`}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          />
                        </div>
                        {formik.errors?.data?.[dateIndex]?.times?.[notifIndex]
                          ?.title &&
                          formik.touched?.data?.[dateIndex]?.times?.[notifIndex]
                            ?.title && (
                            <div className="error-message">
                              {
                                formik.errors?.data?.[dateIndex]?.times?.[
                                  notifIndex
                                ]?.title
                              }
                            </div>
                          )}
                      </div>
                      <div className="formInputBox">
                        <label>
                          Start Time
                          <span className="text-danger">*</span>
                        </label>
                        <div className="formWapper">
                          <input
                            type="time"
                            name={`data[${dateIndex}].times[${notifIndex}].time`}
                            value={
                              formik.values.data?.[dateIndex]?.times?.[
                                notifIndex
                              ]?.time || ""
                            }
                            className={`inputClass ${
                              formik.errors.data?.[dateIndex]?.times?.[
                                notifIndex
                              ]?.time &&
                              formik.touched.data?.[dateIndex]?.times?.[
                                notifIndex
                              ]
                                ? "formError"
                                : ""
                            }`}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          />
                        </div>
                        {formik.touched.data?.[dateIndex]?.times?.[notifIndex]
                          ?.time &&
                        formik.errors.data?.[dateIndex]?.times?.[notifIndex]
                          ?.time ? (
                          <div className="error-message">
                            {
                              formik.errors.data?.[dateIndex]?.times?.[
                                notifIndex
                              ]?.time
                            }
                          </div>
                        ) : null}
                      </div>
                      <div className="formInputBox">
                        <label>Dynamic URL</label>
                        <div className="formWapper">
                          <input
                            type="text"
                            name={`data[${dateIndex}].times[${notifIndex}].dynamic_link`}
                            placeholder="Dynamic URL"
                            value={
                              formik.values.data?.[dateIndex]?.times?.[
                                notifIndex
                              ]?.dynamic_link || ""
                            }
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            className="inputClass"
                          />
                        </div>
                        {formik.touched.data?.[dateIndex]?.times?.[notifIndex]
                          ?.dynamic_link &&
                        formik.errors.data?.[dateIndex]?.times?.[notifIndex]
                          ?.dynamic_link ? (
                          <div className="error-message">
                            {
                              formik.errors.data?.[dateIndex]?.times?.[
                                notifIndex
                              ]?.dynamic_link
                            }
                          </div>
                        ) : null}
                      </div>
                      <div className="formInputBox">
                        <label>Upload image</label>

                        <div
                          className=""
                          style={{
                            width: "100%",
                            height: "100%",
                            backgroundColor: "#fff",
                            borderRadius: "10px",
                          }}
                        >
                          {!formik.values.data?.[dateIndex]?.times?.[notifIndex]
                            ?.image ? (
                            <div>
                              <input
                                type="file"
                                name={`data[${dateIndex}].times[${notifIndex}].image`}
                                className={`formInput`}
                                onChange={async (event) => {
                                  const res = await addToCloudfront(
                                    event.currentTarget.files[0]
                                  );

                                  if (res?.payload?.status === true) {
                                    formik.setFieldValue(
                                      `data[${dateIndex}].times[${notifIndex}].image`,
                                      res?.payload?.img_url || ""
                                    );
                                  }
                                }}
                              />

                              {formik.touched.data?.[dateIndex]?.times?.[
                                notifIndex
                              ]?.image &&
                              formik.errors.data?.[dateIndex]?.times?.[
                                notifIndex
                              ]?.image ? (
                                <div className="error-message">
                                  {
                                    formik.errors.data?.[dateIndex]?.times?.[
                                      notifIndex
                                    ]?.image
                                  }
                                </div>
                              ) : null}
                            </div>
                          ) : (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                                background: "#fff",
                                padding: "10px",
                                borderRadius: "10px",
                              }}
                            >
                              <ImagePreview
                                image={
                                  formik.values.data?.[dateIndex]?.times?.[
                                    notifIndex
                                  ]?.image
                                }
                                handelRemove={() =>
                                  formik.setFieldValue(
                                    `data[${dateIndex}].times[${notifIndex}].image`,
                                    ""
                                  )
                                }
                              />

                              <div
                                style={{
                                  padding: "10px",
                                }}
                              >
                                <input
                                  type="file"
                                  name={`data[${dateIndex}].times[${notifIndex}].image`}
                                  className={`formInput`}
                                  id="profileInput"
                                  style={{
                                    display: "none",
                                  }}
                                  onChange={async (event) => {
                                    const res = await addToCloudfront(
                                      event.currentTarget.files[0]
                                    );

                                    if (res?.payload?.status === true) {
                                      formik.setFieldValue(
                                        `data[${dateIndex}].times[${notifIndex}].image`,
                                        res?.payload?.img_url || ""
                                      );
                                    }
                                  }}
                                />
                                <label
                                  style={{
                                    cursor: "pointer",
                                    color: "blue",
                                    textDecoration: "underline",
                                    fontSize: "20px",
                                  }}
                                  htmlFor="profileInput"
                                >
                                  Change
                                </label>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>

                      <div
                        className="formInputBox"
                        style={{
                          gridColumn: "span 2",
                        }}
                      >
                        <label>
                          Message
                          <span className="text-danger">*</span>
                        </label>

                        <textarea
                          type="text"
                          name={`data[${dateIndex}].times[${notifIndex}].message`}
                          className={`inputClass ${
                            formik.errors.data?.[dateIndex]?.times?.[notifIndex]
                              ?.message &&
                            formik.touched.data?.[dateIndex]?.times?.[
                              notifIndex
                            ]?.message
                              ? "formError"
                              : ""
                          }`}
                          placeholder="Message"
                          value={
                            formik.values.data?.[dateIndex]?.times?.[notifIndex]
                              ?.message || ""
                          }
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          style={{ height: "100px", padding: "10px" }}
                        />
                        {formik.touched.data?.[dateIndex]?.times?.[notifIndex]
                          ?.message &&
                        formik.errors.data?.[dateIndex]?.times?.[notifIndex]
                          ?.message ? (
                          <div className="error-message">
                            {
                              formik.errors.data?.[dateIndex]?.times?.[
                                notifIndex
                              ]?.message
                            }
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </>
        )}
      </form>
    </div>
  );
};

export default AddNotification;

const BoldLabel = ({ children, onClick }) => {
  return (
    <div
      onClick={onClick}
      style={{
        fontWeight: "600",
        fontSize: "20px",
        paddingBottom: "10px",
        color: "green",
        cursor: "pointer",
        width: "fit-content",
      }}
    >
      {children}
    </div>
  );
};

const ImagePreview = ({ image, handelRemove }) => {
  return (
    <div style={{ position: "relative" }}>
      <img
        src={typeof image === "string" ? image : URL.createObjectURL(image)}
        alt="Preview"
        style={{ width: "100px", height: "100px", objectFit: "contain" }}
      />

      <button type="button" className="remove-image-btn" onClick={handelRemove}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-x"
          viewBox="0 0 16 16"
        >
          <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
        </svg>
      </button>
    </div>
  );
};
